// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"7b3918ea","313":"54bb9e9a","361":"b47c3dc2"}[chunkId] + ".chunk.js";
};